<nb-card [nbSpinner]="loading()" class="equipment-walkarounds">
  <nb-card-body>
    @if (error()) {
      <p class="muted">Could not load walk-arounds.</p>
    } @else if (!loading() && rows().length === 0) {
      <p class="muted" data-testid="equipment-walkarounds-empty">
        No walk-arounds recorded for this equipment.
      </p>
    } @else {
      <p class="muted">Select one walk-around to view it, or two to compare.</p>
      <table class="walkaround-table">
        <thead>
          <tr>
            <th></th>
            <th>Date</th>
            <th>Method</th>
            <th>Direction</th>
            <th>Damages</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track row.id) {
            <tr
              [class.selected]="isSelected(row.id)"
              (click)="toggle(row.id)"
              (keydown)="onRowKeydown($event, row.id)"
              tabindex="0"
              data-testid="equipment-walkaround-row"
            >
              <td>
                <nb-checkbox
                  [checked]="isSelected(row.id)"
                  (click)="$event.stopPropagation()"
                  (checkedChange)="toggle(row.id)"
                  [attr.aria-label]="'Select walk-around ' + (row.capturedAt | date: 'short')"
                ></nb-checkbox>
              </td>
              <td>{{ row.capturedAt | date: 'medium' }}</td>
              <td>{{ row.method }}</td>
              <td>{{ row.direction || '—' }}</td>
              <td [class.has-damage]="damageCount(row) > 0">{{ damageCount(row) }}</td>
            </tr>
          }
        </tbody>
      </table>

      @if (selected().length === 2) {
        <stack-mono-walkaround-compare
          [previous]="selected()[0]"
          [current]="selected()[1]"
          previousTitle="Earlier"
          currentTitle="Later"
        ></stack-mono-walkaround-compare>
      } @else if (selected().length === 1) {
        <stack-mono-walkaround-summary
          [record]="selected()[0]"
          [showCompare]="false"
        ></stack-mono-walkaround-summary>
      }
    }
  </nb-card-body>
</nb-card>
